import * as React from "react";
import { forwardRef, memo } from "react";
const SvgArrowDropDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("mask", { id: "mask0_583_39849", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 24, height: 24 }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24 })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_583_39849)" }, /* @__PURE__ */ React.createElement("path", { d: "M12 15L7 10H17L12 15Z" })));
const ForwardRef = forwardRef(SvgArrowDropDown);
const Memo = memo(ForwardRef);
export { Memo as ReactComponent };
